import { ClerkProvider } from "@clerk/clerk-react";
import { createRoot } from "react-dom/client";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppModeProvider } from "./app-mode.js";
import { AuthGate } from "./AuthGate.js";
import { ModeRoot } from "./ModeRoot.js";
import {
	applyResolvedTheme,
	readThemePreference,
	resolveTheme,
} from "./theme.js";
import "./styles.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY?.trim();
if (!publishableKey) {
	throw new Error(
		"Missing VITE_CLERK_PUBLISHABLE_KEY — copy frontend/matrix/.env.example to .env",
	);
}

applyResolvedTheme(resolveTheme(readThemePreference()));

// Break any prior Clerk hash redirect loop left in the address bar.
if (window.location.hash.includes("redirect_url")) {
	const mode = window.location.hash.toLowerCase().includes("sign-up")
		? "#sign-up"
		: "#sign-in";
	window.history.replaceState(null, "", `${window.location.pathname}${mode}`);
}

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

// No React StrictMode here: it double-mounts <SignIn/>/<SignUp/> in dev, and
// each mount hits Clerk's Create SignIn/SignUp limit (5 / 10s).
createRoot(root).render(
	<ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/">
		<TooltipProvider delayDuration={300}>
			<AuthGate>
				<AppModeProvider>
					<ModeRoot />
				</AppModeProvider>
			</AuthGate>
		</TooltipProvider>
	</ClerkProvider>,
);
